'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('business-directory', {
      url: '/business/directory',
      template: '<business-directory></business-directory>',
        authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/directories/business/business-directory.routes.js